"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAppUrl = void 0;
const router_1 = __importDefault(require("next/router"));
const helpers_1 = require("../helpers");
const client_1 = require("../storeLocale/client");
const updateRoute = (nextApp, buildUrl, shallow, scroll = false) => {
    if (typeof window !== 'undefined') {
        // Weird Hack to Make sure that the URL Changes/Updates before fetching New PAGE
        // PROBLEM: Next will Fetch the Page then update URL
        // Update the url immediately when navigating on the frontend between next
        // pages. Without this, Next will fetch page data and then change the url when
        // the page data is retrieved. This would be fine, but it might not finish
        // doing this before the store is created. The store is built based on the new
        // url, so if the url is not updated yet, it will build based on the previous
        // page, which is incorrect. This prevents that race condition by updating the
        // url directly.
        // Very Important for using POPSTATE ( Browser Forward/Back Buttons)
        // The Redux Store just needs to be able to Parse URL to update redux Store
        window.history.pushState({
            url: nextApp,
            as: buildUrl,
            options: {
                shallow,
            },
        }, '', buildUrl);
        router_1.default.replace(`${nextApp}${nextApp.search(/\?/) > -1 ? `&ts=` : `?ts=`}${Date.now()}`, buildUrl, {
            shallow: shallow !== null && shallow !== void 0 ? shallow : undefined,
            scroll, // NextJS 10.2 - Optional boolean, controls scrolling to the top of the page after navigation. Defaults to true
        }); // This will run a replace, not build out history
    }
};
// Payload => { app: '/public/browse', href: '/all/abstract?page=2' }
const updateAppUrl = (_a) => __awaiter(void 0, [_a], void 0, function* ({ app, href, scroll = false }) {
    // const currentPage = Selectors.getPagePath({ ...store.value })
    const { pathname, search } = window.location;
    // We NEED to break down search and merge/overwrite QUERY
    const queryObject = (0, helpers_1.stringToQueryObject)(search);
    const queryString = (0, helpers_1.objectToQueryString)(Object.assign({}, queryObject));
    const queryStringToHref = queryString !== '' ? `?${queryString}` : '';
    const currentHref = `${pathname}${queryStringToHref}`;
    // TODO - GEO PRICES
    // Lets Update the STORE LOCALE in ONE Place - HERE
    // Also check that href does NOT already contain a STORE LOCALE
    const storeLocaleHREF = (0, client_1.addStoreLocaleByCookie)(href);
    if (storeLocaleHREF !== currentHref) {
        updateRoute(app, storeLocaleHREF, false, scroll);
    }
});
exports.updateAppUrl = updateAppUrl;
